module.exports = __webpack_public_path__ + "static/img/image-shirt.5ded703d.jpg";